// eslint-disable-next-line
export const emailTemplate = ({ name = '', email = '', introduction = '', subject = '', subText = '' }) => {
  return (
    '<html xmlns="http://www.w3.org/1999/xhtml">' +
    '<head>' +
    '	<meta http-equiv="content-type" content="text/html; charset=utf-8">' +
    '  	<meta name="viewport" content="width=device-width, initial-scale=1.0;">' +
    ' 	<meta name="format-detection" content="telephone=no"/>' +
    '' +
    '	<!-- Responsive Mobile-First Email Template by Konstantin Savchenko, 2015.' +
    '	https://www.genchealth.com/  -->' +
    '' +
    '	<style>' +
    '/* Reset styles */ ' +
    'body { margin: 0; padding: 0; min-width: 100%; width: 100% !important; height: 100% !important;}' +
    'body, table, td, div, p, a { -webkit-font-smoothing: antialiased; text-size-adjust: 100%; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%; line-height: 100%; }' +
    'table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; border-collapse: collapse !important; border-spacing: 0; }' +
    'img { border: 0; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; }' +
    '#outlook a { padding: 0; }' +
    '.ReadMsgBody { width: 100%; } .ExternalClass { width: 100%; }' +
    '.ExternalClass, .ExternalClass p, .ExternalClass span, .ExternalClass font, .ExternalClass td, .ExternalClass div { line-height: 100%; }' +
    '' +
    '/* Rounded corners for advanced mail clients only */ ' +
    '@media all and (min-width: 560px) {' +
    '	.container { border-radius: 8px; -webkit-border-radius: 8px; -moz-border-radius: 8px; -khtml-border-radius: 8px;}' +
    '}' +
    '' +
    '/* Set color for auto links (addresses, dates, etc.) */ ' +
    'a, a:hover {' +
    '	color: #127DB3;' +
    '}' +
    '.footer a, .footer a:hover {' +
    '	color: #999999;' +
    '}' +
    '' +
    ' 	</style>' +
    '' +
    '	<!-- MESSAGE SUBJECT -->' +
    '	<title>' + subject + '</title>' +
    '' +
    '</head>' +
    '' +
    '<!-- BODY -->' +
    '<!-- Set message background color (twice) and text color (twice) -->' +
    '<body topmargin="0" rightmargin="0" bottommargin="0" leftmargin="0" marginwidth="0" marginheight="0" width="100%" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; width: 100%; height: 100%; -webkit-font-smoothing: antialiased; text-size-adjust: 100%; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%; line-height: 100%;' +
    '	background-color: #F0F0F0;' +
    '	color: #000000;"' +
    '	bgcolor="#F0F0F0"' +
    '	text="#000000">' +
    '' +
    '<!-- SECTION / BACKGROUND -->' +
    '<!-- Set message background color one again -->' +
    '<table width="100%" align="center" border="0" cellpadding="0" cellspacing="0" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; width: 100%;" class="background"><tr><td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0;"' +
    '	bgcolor="#F0F0F0">' +
    '' +
    '<!-- WRAPPER -->' +
    '<!-- Set wrapper width (twice) -->' +
    '<table border="0" cellpadding="0" cellspacing="0" align="center"' +
    '	width="560" style="border-collapse: collapse; border-spacing: 0; padding: 0; width: inherit;' +
    '	max-width: 560px;" class="wrapper">' +
    '' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%;' +
    '			padding-top: 20px;' +
    '			padding-bottom: 20px;">' +
    '' +
    '			<!-- PREHEADER -->' +
    '			<!-- Set text color to background color -->' +
    '			<div style="display: none; visibility: hidden; overflow: hidden; opacity: 0; font-size: 1px; line-height: 1px; height: 0; max-height: 0; max-width: 0;' +
    '			color: #F0F0F0;" class="preheader">' +
    '				Name: ' + name + '</div>' +
    '			<div style="display: none; visibility: hidden; overflow: hidden; opacity: 0; font-size: 1px; line-height: 1px; height: 0; max-height: 0; max-width: 0;' +
    '			color: #F0F0F0;" class="preheader">' +
    '				Email: ' + email + '</div>' +
    '			<div style="display: none; visibility: hidden; overflow: hidden; opacity: 0; font-size: 1px; line-height: 1px; height: 0; max-height: 0; max-width: 0;' +
    '			color: #F0F0F0;" class="preheader">' +
    '				Message: ' + introduction + '</div>' +
    // '' +
    // '			<!-- LOGO -->' +
    // '			<!-- Image text color should be opposite to background color. Set your url, image src, alt and title. Alt text should fit the image size. Real image size should be x2. URL format: http://domain.com/?utm_source={{Campaign-Source}}&utm_medium=email&utm_content=logo&utm_campaign={{Campaign-Name}} -->' +
    // '			<a target="_blank" style="text-decoration: none;"' +
    // '				href="https://www.genchealth.com/"><img border="0" vspace="0" hspace="0"' +
    // '				src="https://genc-landing.netlify.app/images/logo_Final_cut.png"' +
    // '				width="100" height="30"' +
    // '				alt="Logo" title="Logo" style="' +
    // '				color: #000000;' +
    // '				font-size: 10px; margin: 0; padding: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; border: none; display: block;" /></a>' +
    // '' +
    '		</td>' +
    '	</tr>' +
    '' +
    '<!-- End of WRAPPER -->' +
    '</table>' +
    '' +
    '<!-- WRAPPER / CONTEINER -->' +
    '<!-- Set conteiner background color -->' +
    '<table border="0" cellpadding="0" cellspacing="0" align="center"' +
    '	bgcolor="#FFFFFF"' +
    '	width="560" style="border-collapse: collapse; border-spacing: 0; padding: 0; width: inherit;' +
    '	max-width: 560px;" class="container">' +
    '' +
    '	<!-- HEADER -->' +
    '	<!-- Set text color and font family ("sans-serif" or "Georgia, serif") -->' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%; font-size: 24px; font-weight: bold; line-height: 130%;' +
    '			padding-top: 25px;' +
    '			color: #000000;' +
    '			font-family: sans-serif;" class="header">' +
    subject +
    '		</td>' +
    '	</tr>' +
    '	' +
    '	<!-- SUBHEADER -->' +
    '	<!-- Set text color and font family ("sans-serif" or "Georgia, serif") -->' +
    '<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-bottom: 3px; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%; font-size: 18px; font-weight: 300; line-height: 150%;' +
    '			padding-top: 5px;' +
    '			color: #000000;' +
    '			font-family: sans-serif;" class="subheader">' +
    subText +
    '		</td>' +
    '	</tr>' +
    '' +
    '	<!-- HERO IMAGE -->' +
    '	<!-- Image text color should be opposite to background color. Set your url, image src, alt and title. Alt text should fit the image size. Real image size should be x2 (wrapper x2). Do not set height for flexible images (including "auto"). URL format: http://domain.com/?utm_source={{Campaign-Source}}&utm_medium=email&utm_content={{Ìmage-Name}}&utm_campaign={{Campaign-Name}} -->' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0;' +
    '			padding-top: 20px;" class="hero"><a target="_blank" style="text-decoration: none;"' +
    '			href="https://www.genchealth.com/"><img border="0" vspace="0" hspace="0"' +
    '			src="https://genc-landing.netlify.app/images/idea1.svg"' +
    '			alt="Please enable images to view this content" title="Hero Image"' +
    '			width="560" style="' +
    '			width: 100%;' +
    '			max-width: 560px;' +
    '			color: #000000; font-size: 13px; margin: 0; padding: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; border: none; display: block;"/></a></td>' +
    '	</tr>' +
    '' +
    '	<!-- PARAGRAPH -->' +
    '	<!-- Set text color and font family ("sans-serif" or "Georgia, serif"). Duplicate all text styles in links, including line-height -->' +
    '	<tr>' +
    '		<td align="left" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%; font-size: 17px; font-weight: 400; line-height: 160%;' +
    '			padding-top: 25px; ' +
    '			color: #000000;' +
    '			font-family: sans-serif;" class="paragraph">' +
    '			<div style="	color: #000000;font-family: sans-serif;font-size: 17px; font-weight: 400; line-height: 160%;"  class="preheader">' +
    '				Name: ' + name + '</div>' +
    '			<div style="	color: #000000;font-family: sans-serif;font-size: 17px; font-weight: 400; line-height: 160%;"  class="preheader">' +
    '				Email: ' + email + '</div>' +
    '			<div  style="	color: #000000;font-family: sans-serif;font-size: 17px; font-weight: 400; line-height: 160%;"  class="preheader">' +
    '				Message: ' + introduction + '</div>' +
    +
    '		</td>' +
    '	</tr>' +
    '' +
    '	<!-- BUTTON -->' +
    '	<!-- Set button background color at TD, link/text color at A and TD, font family ("sans-serif" or "Georgia, serif") at TD. For verification codes add "letter-spacing: 5px;". Link format: http://domain.com/?utm_source={{Campaign-Source}}&utm_medium=email&utm_content={{Button-Name}}&utm_campaign={{Campaign-Name}} -->' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%;' +
    '			padding-top: 25px;' +
    '			padding-bottom: 5px;" class="button"><a' +
    '			href="https://www.genchealth.com/" target="_blank" style="text-decoration: underline;">' +
    '				<table border="0" cellpadding="0" cellspacing="0" align="center" style="max-width: 240px; min-width: 120px; border-collapse: collapse; border-spacing: 0; padding: 0;"><tr><td align="center" valign="middle" style="padding: 12px 24px; margin: 0; text-decoration: underline; border-collapse: collapse; border-spacing: 0; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; -khtml-border-radius: 4px;"' +
    '					bgcolor="#E9703E"><a target="_blank" style="text-decoration: underline;' +
    '					color: #FFFFFF; font-family: sans-serif; font-size: 17px; font-weight: 400; line-height: 120%;"' +
    '					href="https://www.genchealth.com/">' +
    '						Go to Genc Health' +
    '					</a>' +
    '			</td></tr></table></a>' +
    '		</td>' +
    '	</tr>' +
    '' +
    // '	<!-- LINE -->' +
    // '	<!-- Set line color -->' +
    // '	<tr>	' +
    // '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%;' +
    // '			padding-top: 25px;" class="line"><hr' +
    // '			color="#E0E0E0" align="center" width="100%" size="1" noshade style="margin: 0; padding: 0;" />' +
    // '		</td>' +
    // '	</tr>' +
    // '' +
    // '	<!-- LIST -->' +
    // '	<tr>' +
    // '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%;" class="list-item"><table align="center" border="0" cellspacing="0" cellpadding="0" style="width: inherit; margin: 0; padding: 0; border-collapse: collapse; border-spacing: 0;">' +
    // '			' +
    // '			<!-- LIST ITEM -->' +
    // '			<tr>' +
    // '' +
    // '				<!-- LIST ITEM IMAGE -->' +
    // '				<!-- Image text color should be opposite to background color. Set your url, image src, alt and title. Alt text should fit the image size. Real image size should be x2 -->' +
    // '				<td align="left" valign="top" style="border-collapse: collapse; border-spacing: 0;' +
    // '					padding-top: 30px;' +
    // '					padding-right: 20px;"><img' +
    // '				border="0" vspace="0" hspace="0" style="padding: 0; margin: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; border: none; display: block;' +
    // '					color: #000000;"' +
    // '					src="https://raw.githubusercontent.com/konsav/email-templates/master/images/list-item.png"' +
    // '					alt="H" title="Highly compatible"' +
    // '					width="50" height="50"></td>' +
    // '' +
    // '				<!-- LIST ITEM TEXT -->' +
    // '				<!-- Set text color and font family ("sans-serif" or "Georgia, serif"). Duplicate all text styles in links, including line-height -->' +
    // '				<td align="left" valign="top" style="font-size: 17px; font-weight: 400; line-height: 160%; border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0;' +
    // '					padding-top: 25px;' +
    // '					color: #000000;' +
    // '					font-family: sans-serif;" class="paragraph">' +
    // '						<b style="color: #333333;">Highly compatible</b><br/>' +
    // '						Tested on the most popular email clients for web, desktop and mobile. Checklist included.' +
    // '				</td>' +
    // '' +
    // '			</tr>' +
    // '' +
    // '			<!-- LIST ITEM -->' +
    // '			<tr>' +
    // '' +
    // '				<!-- LIST ITEM IMAGE -->' +
    // '				<!-- Image text color should be opposite to background color. Set your url, image src, alt and title. Alt text should fit the image size. Real image size should be x2 -->' +
    // '				<td align="left" valign="top" style="border-collapse: collapse; border-spacing: 0;' +
    // '					padding-top: 30px;' +
    // '					padding-right: 20px;"><img' +
    // '				border="0" vspace="0" hspace="0" style="padding: 0; margin: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; border: none; display: block;' +
    // '					color: #000000;"' +
    // '					src="https://raw.githubusercontent.com/konsav/email-templates/master/images/list-item.png"' +
    // '					alt="D" title="Designer friendly"' +
    // '					width="50" height="50"></td>' +
    // '' +
    // '				<!-- LIST ITEM TEXT -->' +
    // '				<!-- Set text color and font family ("sans-serif" or "Georgia, serif"). Duplicate all text styles in links, including line-height -->' +
    // '				<td align="left" valign="top" style="font-size: 17px; font-weight: 400; line-height: 160%; border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0;' +
    // '					padding-top: 25px;' +
    // '					color: #000000;' +
    // '					font-family: sans-serif;" class="paragraph">' +
    // '						<b style="color: #333333;">Designer friendly</b><br/>' +
    // '						Sketch app resource file and a bunch of social media icons are also included in GitHub repository.' +
    // '				</td>' +
    // '' +
    // '			</tr>' +
    // '' +
    // '		</table></td>' +
    // '	</tr>' +
    // '' +
    // '	<!-- LINE -->' +
    '	<!-- Set line color -->' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%;' +
    '			padding-top: 25px;" class="line"><hr' +
    '			color="#E0E0E0" align="center" width="100%" size="1" noshade style="margin: 0; padding: 0;" />' +
    '		</td>' +
    '	</tr>' +
    '' +
    '	<!-- PARAGRAPH -->' +
    '	<!-- Set text color and font family ("sans-serif" or "Georgia, serif"). Duplicate all text styles in links, including line-height -->' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%; font-size: 17px; font-weight: 400; line-height: 160%;' +
    '			padding-top: 20px;' +
    '			padding-bottom: 25px;' +
    '			color: #000000;' +
    '			font-family: sans-serif;" class="paragraph">' +
    '				Have a question? <a href="mailto:support@angelo.network" target="_blank" style="color: #127DB3; font-family: sans-serif; font-size: 17px; font-weight: 400; line-height: 160%;">support@angelo.network</a>' +
    '		</td>' +
    '	</tr>' +
    '' +
    '<!-- End of WRAPPER -->' +
    '</table>' +
    '' +
    '<!-- WRAPPER -->' +
    '<!-- Set wrapper width (twice) -->' +
    '<table border="0" cellpadding="0" cellspacing="0" align="center"' +
    '	width="560" style="border-collapse: collapse; border-spacing: 0; padding: 0; width: inherit;' +
    '	max-width: 560px;" class="wrapper">' +
    '' +
    '	<!-- SOCIAL NETWORKS -->' +
    '	<!-- Image text color should be opposite to background color. Set your url, image src, alt and title. Alt text should fit the image size. Real image size should be x2 -->' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%;' +
    '			padding-top: 25px;" class="social-icons"><table' +
    '			width="256" border="0" cellpadding="0" cellspacing="0" align="center" style="border-collapse: collapse; border-spacing: 0; padding: 0;">' +
    '			<tr>' +
    '' +
    '				<!-- ICON 1 -->' +
    '				<td align="center" valign="middle" style="margin: 0; padding: 0; padding-left: 10px; padding-right: 10px; border-collapse: collapse; border-spacing: 0;"><a target="_blank"' +
    '					href="https://www.facebook.com/genchealth/"' +
    '				style="text-decoration: none;"><img border="0" vspace="0" hspace="0" style="padding: 0; margin: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; border: none; display: inline-block;' +
    '					color: #000000;"' +
    '					alt="F" title="Facebook"' +
    '					width="44" height="44"' +
    '					src="https://raw.githubusercontent.com/konsav/email-templates/master/images/social-icons/facebook.png"></a></td>' +
    '' +
    '				<!-- ICON 2 -->' +
    '				<td align="center" valign="middle" style="margin: 0; padding: 0; padding-left: 10px; padding-right: 10px; border-collapse: collapse; border-spacing: 0;"><a target="_blank"' +
    '					href="https://twitter.com/GenCLabs"' +
    '				style="text-decoration: none;"><img border="0" vspace="0" hspace="0" style="padding: 0; margin: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; border: none; display: inline-block;' +
    '					color: #000000;"' +
    '					alt="T" title="Twitter"' +
    '					width="44" height="44"' +
    '					src="https://raw.githubusercontent.com/konsav/email-templates/master/images/social-icons/twitter.png"></a></td>				' +
    // '' +
    // '				<!-- ICON 3 -->' +
    // '				<td align="center" valign="middle" style="margin: 0; padding: 0; padding-left: 10px; padding-right: 10px; border-collapse: collapse; border-spacing: 0;"><a target="_blank"' +
    // '					href="https://raw.githubusercontent.com/konsav/email-templates/"' +
    // '				style="text-decoration: none;"><img border="0" vspace="0" hspace="0" style="padding: 0; margin: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; border: none; display: inline-block;' +
    // '					color: #000000;"' +
    // '					alt="G" title="Google Plus"' +
    // '					width="44" height="44"' +
    // '					src="https://raw.githubusercontent.com/konsav/email-templates/master/images/social-icons/googleplus.png"></a></td>		' +
    // '' +
    // '				<!-- ICON 4 -->' +
    // '				<td align="center" valign="middle" style="margin: 0; padding: 0; padding-left: 10px; padding-right: 10px; border-collapse: collapse; border-spacing: 0;"><a target="_blank"' +
    // '					href="https://raw.githubusercontent.com/konsav/email-templates/"' +
    // '				style="text-decoration: none;"><img border="0" vspace="0" hspace="0" style="padding: 0; margin: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; border: none; display: inline-block;' +
    // '					color: #000000;"' +
    // '					alt="I" title="Instagram"' +
    // '					width="44" height="44"' +
    // '					src="https://raw.githubusercontent.com/konsav/email-templates/master/images/social-icons/instagram.png"></a></td>' +
    // '' +
    '			</tr>' +
    '			</table>' +
    '		</td>' +
    '	</tr>' +
    '' +
    '	<!-- FOOTER -->' +
    '	<!-- Set text color and font family ("sans-serif" or "Georgia, serif"). Duplicate all text styles in links, including line-height -->' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%; font-size: 13px; font-weight: 400; line-height: 150%;' +
    '			padding-top: 20px;' +
    '			padding-bottom: 20px;' +
    '			color: #999999;' +
    '			font-family: sans-serif;" class="footer">' +
    '' +
    '			Sincerely,	The Genc team <a href="https://www.genchealth.com/" target="_blank" style="text-decoration: underline; color: #999999; font-family: sans-serif; font-size: 13px; font-weight: 400; line-height: 150%;">https://www.genchealth.com/</a> ' +
    '' +
    '				<!-- ANALYTICS -->' +
    '				<!-- https://www.google-analytics.com/collect?v=1&tid={{UA-Tracking-ID}}&cid={{Client-ID}}&t=event&ec=email&ea=open&cs={{Campaign-Source}}&cm=email&cn={{Campaign-Name}} -->' +
    '				<img width="1" height="1" border="0" vspace="0" hspace="0" style="margin: 0; padding: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; border: none; display: block;"' +
    '				src="https://raw.githubusercontent.com/konsav/email-templates/master/images/tracker.png" />' +
    '' +
    '		</td>' +
    '	</tr>' +
    '' +
    '<!-- End of WRAPPER -->' +
    '</table>' +
    '' +
    '<!-- End of SECTION / BACKGROUND -->' +
    '</td></tr></table>' +
    '' +
    '</body>' +
    '</html>'
  )
}

// eslint-disable-next-line
export const emailTemplateWaitingList = ({ subject = '', subText = '' }) => {
  return (
    '<html xmlns="http://www.w3.org/1999/xhtml">' +
    '<head>' +
    '	<meta http-equiv="content-type" content="text/html; charset=utf-8">' +
    '  	<meta name="viewport" content="width=device-width, initial-scale=1.0;">' +
    ' 	<meta name="format-detection" content="telephone=no"/>' +
    '' +
    '	<!-- Responsive Mobile-First Email Template by Konstantin Savchenko, 2015.' +
    '	https://www.genchealth.com/  -->' +
    '' +
    '	<style>' +
    '/* Reset styles */ ' +
    'body { margin: 0; padding: 0; min-width: 100%; width: 100% !important; height: 100% !important;}' +
    'body, table, td, div, p, a { -webkit-font-smoothing: antialiased; text-size-adjust: 100%; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%; line-height: 100%; }' +
    'table, td { mso-table-lspace: 0pt; mso-table-rspace: 0pt; border-collapse: collapse !important; border-spacing: 0; }' +
    'img { border: 0; line-height: 100%; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; }' +
    '#outlook a { padding: 0; }' +
    '.ReadMsgBody { width: 100%; } .ExternalClass { width: 100%; }' +
    '.ExternalClass, .ExternalClass p, .ExternalClass span, .ExternalClass font, .ExternalClass td, .ExternalClass div { line-height: 100%; }' +
    '' +
    '/* Rounded corners for advanced mail clients only */ ' +
    '@media all and (min-width: 560px) {' +
    '	.container { border-radius: 8px; -webkit-border-radius: 8px; -moz-border-radius: 8px; -khtml-border-radius: 8px;}' +
    '}' +
    '' +
    '/* Set color for auto links (addresses, dates, etc.) */ ' +
    'a, a:hover {' +
    '	color: #127DB3;' +
    '}' +
    '.footer a, .footer a:hover {' +
    '	color: #999999;' +
    '}' +
    '' +
    ' 	</style>' +
    '' +
    '	<!-- MESSAGE SUBJECT -->' +
    '	<title>' + subject + '</title>' +
    '' +
    '</head>' +
    '' +
    '<!-- BODY -->' +
    '<!-- Set message background color (twice) and text color (twice) -->' +
    '<body topmargin="0" rightmargin="0" bottommargin="0" leftmargin="0" marginwidth="0" marginheight="0" width="100%" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; width: 100%; height: 100%; -webkit-font-smoothing: antialiased; text-size-adjust: 100%; -ms-text-size-adjust: 100%; -webkit-text-size-adjust: 100%; line-height: 100%;' +
    '	background-color: #F0F0F0;' +
    '	color: #000000;"' +
    '	bgcolor="#F0F0F0"' +
    '	text="#000000">' +
    '' +
    '<!-- SECTION / BACKGROUND -->' +
    '<!-- Set message background color one again -->' +
    '<table width="100%" align="center" border="0" cellpadding="0" cellspacing="0" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; width: 100%;" class="background"><tr><td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0;"' +
    '	bgcolor="#F0F0F0">' +
    '' +
    '<!-- WRAPPER -->' +
    '<!-- Set wrapper width (twice) -->' +
    '<table border="0" cellpadding="0" cellspacing="0" align="center"' +
    '	width="560" style="border-collapse: collapse; border-spacing: 0; padding: 0; width: inherit;' +
    '	max-width: 560px;" class="wrapper">' +
    '' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%;' +
    '			padding-top: 20px;' +
    '			padding-bottom: 20px;">' +
    '' +
    '		</td>' +
    '	</tr>' +
    '' +
    '<!-- End of WRAPPER -->' +
    '</table>' +
    '' +
    '<!-- WRAPPER / CONTEINER -->' +
    '<!-- Set conteiner background color -->' +
    '<table border="0" cellpadding="0" cellspacing="0" align="center"' +
    '	bgcolor="#FFFFFF"' +
    '	width="560" style="border-collapse: collapse; border-spacing: 0; padding: 0; width: inherit;' +
    '	max-width: 560px;" class="container">' +
    '' +
    '	<!-- HEADER -->' +
    '	<!-- Set text color and font family ("sans-serif" or "Georgia, serif") -->' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%; font-size: 24px; font-weight: bold; line-height: 130%;' +
    '			padding-top: 25px;' +
    '			color: #000000;' +
    '			font-family: sans-serif;" class="header">' +
    subject +
    '		</td>' +
    '	</tr>' +
    '	' +
    '	<!-- SUBHEADER -->' +
    '	<!-- Set text color and font family ("sans-serif" or "Georgia, serif") -->' +
    '<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-bottom: 3px; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%; font-size: 18px; font-weight: 300; line-height: 150%;' +
    '			padding-top: 5px;' +
    '			color: #000000;' +
    '			font-family: sans-serif;" class="subheader">' +
    subText +
    '		</td>' +
    '	</tr>' +
    '' +
    '	<!-- HERO IMAGE -->' +
    '	<!-- Image text color should be opposite to background color. Set your url, image src, alt and title. Alt text should fit the image size. Real image size should be x2 (wrapper x2). Do not set height for flexible images (including "auto"). URL format: http://domain.com/?utm_source={{Campaign-Source}}&utm_medium=email&utm_content={{Ìmage-Name}}&utm_campaign={{Campaign-Name}} -->' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0;' +
    '			padding-top: 20px;" class="hero"><a target="_blank" style="text-decoration: none;"' +
    '			href="https://www.genchealth.com/"><img border="0" vspace="0" hspace="0"' +
    '			src="https://genc-landing.netlify.app/images/idea1.svg"' +
    '			alt="Please enable images to view this content" title="Hero Image"' +
    '			width="560" style="' +
    '			width: 100%;' +
    '			max-width: 560px;' +
    '			color: #000000; font-size: 13px; margin: 0; padding: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; border: none; display: block;"/></a></td>' +
    '	</tr>' +
    '' +

    '	<!-- PARAGRAPH -->' +
    '	<!-- Set text color and font family ("sans-serif" or "Georgia, serif"). Duplicate all text styles in links, including line-height -->' +
    '	<tr>' +
    '		<td align="left" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%; font-size: 17px; font-weight: 400; line-height: 160%;' +
    '			padding-top: 25px; ' +
    '			color: #000000;' +
    '			font-family: sans-serif;" class="paragraph">' +
    '<div style="	color: #000000;font-family: sans-serif;font-size: 17px; font-weight: 400; line-height: 160%;"   className="early-modal-title">' +
    '            Interested in priority access ?' +
    '          </div>' +
    '          <div style="	color: #000000;font-family: sans-serif;font-size: 17px; font-weight: 400; line-height: 160%;"   className="early-modal-content">' +
    '            Get early access by referring your friend, The more firend join, the' +
    '            sooner you\'ll get access' +
    '          </div>'
    +
    '		</td>' +
    '	</tr>' +
    '' +

    '	<!-- BUTTON -->' +
    '	<!-- Set button background color at TD, link/text color at A and TD, font family ("sans-serif" or "Georgia, serif") at TD. For verification codes add "letter-spacing: 5px;". Link format: http://domain.com/?utm_source={{Campaign-Source}}&utm_medium=email&utm_content={{Button-Name}}&utm_campaign={{Campaign-Name}} -->' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%;' +
    '			padding-top: 25px;' +
    '			padding-bottom: 5px;" class="button"><a' +
    '			href="https://www.genchealth.com/" target="_blank" style="text-decoration: underline;">' +
    '				<table border="0" cellpadding="0" cellspacing="0" align="center" style="max-width: 240px; min-width: 120px; border-collapse: collapse; border-spacing: 0; padding: 0;"><tr><td align="center" valign="middle" style="padding: 12px 24px; margin: 0; text-decoration: underline; border-collapse: collapse; border-spacing: 0; border-radius: 4px; -webkit-border-radius: 4px; -moz-border-radius: 4px; -khtml-border-radius: 4px;"' +
    '					bgcolor="#E9703E"><a target="_blank" style="text-decoration: underline;' +
    '					color: #FFFFFF; font-family: sans-serif; font-size: 17px; font-weight: 400; line-height: 120%;"' +
    '					href="https://www.genchealth.com/">' +
    '						Go to Genc Health' +
    '					</a>' +
    '			</td></tr></table></a>' +
    '		</td>' +
    '	</tr>' +
    '' +

    '	<!-- Set line color -->' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%;' +
    '			padding-top: 25px;" class="line"><hr' +
    '			color="#E0E0E0" align="center" width="100%" size="1" noshade style="margin: 0; padding: 0;" />' +
    '		</td>' +
    '	</tr>' +
    '' +
    '	<!-- PARAGRAPH -->' +
    '	<!-- Set text color and font family ("sans-serif" or "Georgia, serif"). Duplicate all text styles in links, including line-height -->' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%; font-size: 17px; font-weight: 400; line-height: 160%;' +
    '			padding-top: 20px;' +
    '			padding-bottom: 25px;' +
    '			color: #000000;' +
    '			font-family: sans-serif;" class="paragraph">' +
    '				Have a question? <a href="mailto:support@angelo.network" target="_blank" style="color: #127DB3; font-family: sans-serif; font-size: 17px; font-weight: 400; line-height: 160%;">support@angelo.network</a>' +
    '		</td>' +
    '	</tr>' +
    '' +
    '<!-- End of WRAPPER -->' +
    '</table>' +
    '' +
    '<!-- WRAPPER -->' +
    '<!-- Set wrapper width (twice) -->' +
    '<table border="0" cellpadding="0" cellspacing="0" align="center"' +
    '	width="560" style="border-collapse: collapse; border-spacing: 0; padding: 0; width: inherit;' +
    '	max-width: 560px;" class="wrapper">' +
    '' +
    '	<!-- SOCIAL NETWORKS -->' +
    '	<!-- Image text color should be opposite to background color. Set your url, image src, alt and title. Alt text should fit the image size. Real image size should be x2 -->' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%;' +
    '			padding-top: 25px;" class="social-icons"><table' +
    '			width="256" border="0" cellpadding="0" cellspacing="0" align="center" style="border-collapse: collapse; border-spacing: 0; padding: 0;">' +
    '			<tr>' +
    '' +
    '				<!-- ICON 1 -->' +
    '				<td align="center" valign="middle" style="margin: 0; padding: 0; padding-left: 10px; padding-right: 10px; border-collapse: collapse; border-spacing: 0;"><a target="_blank"' +
    '					href="https://www.facebook.com/genchealth/"' +
    '				style="text-decoration: none;"><img border="0" vspace="0" hspace="0" style="padding: 0; margin: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; border: none; display: inline-block;' +
    '					color: #000000;"' +
    '					alt="F" title="Facebook"' +
    '					width="44" height="44"' +
    '					src="https://raw.githubusercontent.com/konsav/email-templates/master/images/social-icons/facebook.png"></a></td>' +
    '' +
    '				<!-- ICON 2 -->' +
    '				<td align="center" valign="middle" style="margin: 0; padding: 0; padding-left: 10px; padding-right: 10px; border-collapse: collapse; border-spacing: 0;"><a target="_blank"' +
    '					href="https://twitter.com/GenCLabs"' +
    '				style="text-decoration: none;"><img border="0" vspace="0" hspace="0" style="padding: 0; margin: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; border: none; display: inline-block;' +
    '					color: #000000;"' +
    '					alt="T" title="Twitter"' +
    '					width="44" height="44"' +
    '					src="https://raw.githubusercontent.com/konsav/email-templates/master/images/social-icons/twitter.png"></a></td>				' +

    '			</tr>' +
    '			</table>' +
    '		</td>' +
    '	</tr>' +
    '' +
    '	<!-- FOOTER -->' +
    '	<!-- Set text color and font family ("sans-serif" or "Georgia, serif"). Duplicate all text styles in links, including line-height -->' +
    '	<tr>' +
    '		<td align="center" valign="top" style="border-collapse: collapse; border-spacing: 0; margin: 0; padding: 0; padding-left: 6.25%; padding-right: 6.25%; width: 87.5%; font-size: 13px; font-weight: 400; line-height: 150%;' +
    '			padding-top: 20px;' +
    '			padding-bottom: 20px;' +
    '			color: #999999;' +
    '			font-family: sans-serif;" class="footer">' +
    '' +
    '			Sincerely,	The Genc team <a href="https://www.genchealth.com/" target="_blank" style="text-decoration: underline; color: #999999; font-family: sans-serif; font-size: 13px; font-weight: 400; line-height: 150%;">https://www.genchealth.com/</a> ' +
    '' +
    '				<!-- ANALYTICS -->' +
    '				<!-- https://www.google-analytics.com/collect?v=1&tid={{UA-Tracking-ID}}&cid={{Client-ID}}&t=event&ec=email&ea=open&cs={{Campaign-Source}}&cm=email&cn={{Campaign-Name}} -->' +
    '				<img width="1" height="1" border="0" vspace="0" hspace="0" style="margin: 0; padding: 0; outline: none; text-decoration: none; -ms-interpolation-mode: bicubic; border: none; display: block;"' +
    '				src="https://raw.githubusercontent.com/konsav/email-templates/master/images/tracker.png" />' +
    '' +
    '		</td>' +
    '	</tr>' +
    '' +
    '<!-- End of WRAPPER -->' +
    '</table>' +
    '' +
    '<!-- End of SECTION / BACKGROUND -->' +
    '</td></tr></table>' +
    '' +
    '</body>' +
    '</html>'
  )
}